<template>
    <div class="columns">
        <div class="column is-three-quarters">
            <section class="section">
                <div class="container">
                    <div class="columns">
                        <div class="column is-four-fifths">
                            <h1 class="title">Shared Files</h1>
                        </div>
                        <div class="column is-one-fifth">
                            <div class="control">
                                <label class="label" for="organization-select">Filter by organization</label>
                                <div class="select">
                                    <select id="organization-select" v-model="selectedOrganization" required>
                                        <option value="">all</option>
                                        <option v-for="organization in organizations" v-bind:key="organization.id" :value="organization.id">{{organization.name}}</option>
                                    </select>
                                </div>
                            </div> 
                        </div>
                    </div>
                    <file-list :files="filteredFiles" :loading="!loaded"></file-list>
                    <p v-if="loaded && filteredFiles.length === 0">No files are currently shared.</p>
                </div>
            </section>
        </div>
        <div class="column is-one-quarter">
            <section class="section">
                    <h1 class="title">Upload A File</h1>
                    <file-upload></file-upload>
            </section>
        </div>
    </div>
</template>

<script>
    import BButton from "buefy/src/components/button/Button";
    import {mapGetters, mapState} from "vuex";
    // import FileUpload from "../components/FileUpload";
    import FileUpload from "../components/MultipartFileUpload";
    import FileList from "../components/FileList";

    export default {
        data: () => ({
            'selectedOrganization': '',
        }),
        name: "ListFiles",
        components: {FileList, FileUpload, BButton},
        computed: {
            ...mapGetters('files', [
                'goodFiles',
            ]),
            ...mapState('files', [
                'loaded',
            ]),
            ...mapState('user', [
                'organizations',
            ]),

            filteredFiles() {
                if (!this.selectedOrganization) {
                    
                    // If no organization is selected, return all files
                    return this.goodFiles;
                }
                // Return only files that belong to the selected organization
                return this.goodFiles.filter(file => file.Organization === this.selectedOrganization);
            }
        },
        mounted()  {
            this.$store.dispatch('files/getFiles');
        }
    }
</script>

<style scoped>

</style>